export default __webpack_public_path__ + "static/media/jnt.a884f766.png";